//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";
import {parser} from "@/utils/parser";

export default {
  name: "SectionCategoriesSliders",
  components: {
    EmptyEntityCardsSlider: () => import("@/components/common/EmptyEntityCardsSlider"),
    CategoriesComponent: () => import("@/components/common/CategoriesComponent/index"),
    Section: () => import("@/components/common/Section/index"),
  },
  data() {
    return {
      show: true,
      pending: true,
      categories: [],
    };
  },
  computed: {
    ...mapGetters({
      cityId: "municipality/id"
    })
  },
  mounted() {
    const payload = {
      params: {
        resolution: "micro",
        city_id: this.cityId,
        count: 100500,
        lang: this.$i18n.locale
      }
    };
    if (this.cityId) {
      this.$axios.$get(`/api/place_type_categories?${parser(payload)}`)
        .then(async (resolve) => {
          if (resolve?.data?.length > 0) {
            const modifiedCategories = await Promise.all(resolve.data.map(async (item) => {
              item.places = (await Promise.all(item.place_types.map(async (item) => {
                return await this.$axios.$get(`/api/places?${parser({
                  params: {
                    resolution: payload.params.resolution,
                    count: payload.params.count,
                    category_id: item.id,
                    city_id: payload.params.city_id,
                    lang: payload.params.lang
                  }
                })}`)
                  .then(resolve => resolve.data);
              }))).flat(2);
              return item;
            }));
            this.categories = modifiedCategories.filter(item => item?.places?.length > 0);
          }
        })
        .catch(() => null)
        .finally(() => {
          this.pending = false;
          if (this.categories.length === 0) {
            this.show = false;
          }
        });
    }
  }
};
